export const IMAGE_EXTS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'avif', 'ico']
export const VIDEO_EXTS = ['mp4', 'webm', 'mov', 'm4v', 'ogv']
export const AUDIO_EXTS = ['mp3', 'wav', 'ogg', 'm4a', 'aac']

export const kindOf = name => {
  const ext = (name.split('.').pop() || '').toLowerCase()
  if (IMAGE_EXTS.includes(ext)) return 'image'
  if (VIDEO_EXTS.includes(ext)) return 'video'
  if (AUDIO_EXTS.includes(ext)) return 'audio'
  if (ext === 'pdf') return 'pdf'
  if (['txt', 'json', 'csv', 'md', 'log', 'xml', 'html'].includes(ext)) return 'text'
  return 'other'
}
